import React, {useState, useEffect, useRef} from 'react';
import LayersMapOl from '../components/geoData/layer/LayersMapOl';
import MapOl from '../components/geoData/map/MapOl';
import {Point} from 'ol/geom';
import BaseLayers from '../components/geoData/layer/BaseLayers';
import OverlayLayer from '../components/geoData/layer/OverlayLayer';
import {useAppSelector, useAppDispatch} from '../redux/hooks';
import {
    resetData,
    setBaseLayer,
    setPermaLinkLayer,
    setWorkspace,
    isPermaLinkView,
    setBaseWorkspace
} from '../redux/slices/GeomonitoringSlice';
import ConfigLayers from '../components/geoData/layer/ConfigLayers';
import geoSettings from '../config/geoSettings';
import {transformCoords} from '../services/SpatialService';
import {getMapCenter} from "../functions/functionsOpenlayer";

type Props = {
    project: any,
    configActive: boolean,
    onConfigButtonClick: any
    onConfigClick: any
    alarm: any,
    show: boolean,
    toolkitEnabled:boolean,
}

const GeoData = (props: Props): JSX.Element => {
    if (!props.project || Object.keys(props.project).length === 0) return<div></div>;
    const [center, setCenter] = useState([0, 0]);
    const [zoom, setZoom] = useState(9);
    const projectId = props.project.id;
    const refZoom = useRef(zoom);
    const dispatch = useAppDispatch();
    let mapSet = false;



    const getMapCenterData = () => {
        const mapCenterData=getMapCenter(props)
        setZoom(mapCenterData.zoom);
        setCenter(mapCenterData.center);
    };

    useEffect(() => {
        if (!mapSet) {
            const baseWorkspace = props.project.baselayer_workspace !== null ? props.project.baselayer_workspace : geoSettings.wmsWorkspace;
            dispatch(resetData());
            if (props.project.spatialBookmark) {
                dispatch(setPermaLinkLayer(props.project.spatialBookmark.link.visibleLayerIds));
                dispatch(isPermaLinkView(props.project.spatialBookmark.is_permalink));
            }
            dispatch(setWorkspace(props.project.geoserver_workspace));
            dispatch(setBaseLayer(props.project.base_layer));
            dispatch(setBaseWorkspace(baseWorkspace));
            getMapCenterData();
            mapSet = true;
        }
    }, [props.project]);

    useEffect(() => {
        refZoom.current = zoom;
    }, [zoom]);

    useEffect(()=>{
        if (!props.project || Object.keys(props.project).length === 0) return;
    },[])

    /* Überprüfen, ob props notwendig, wenn dispatch*/
    return (<div style={{display: props.show ? 'inline' : 'none'}}>
        {/* Geo Monitoring / Karten Darstellung*/}
        <MapOl key={props.project.id + '_maps'} zoom={zoom} center={center} propElem={props} toolkitEnabled={props.toolkitEnabled}>
            <LayersMapOl key={props.project.id + '_layerMaps'}>
                <BaseLayers projectId={projectId} mapDataWorkBench={props.project.geoserver_workspace}
                            baseLayer={props.project.base_layer}/>
                <OverlayLayer projectId={projectId}/>
                <ConfigLayers projectId={projectId}/>
            </LayersMapOl>
        </MapOl>


    </div>);
};
export default GeoData;
